<section class="contact-form">
	<div class="container_education">
		<div class="contact-form__inner">
			<h3 class="contact-form__title">Оставь свои контакты, чтобы узнать, когда появится новая стажировка</h3>
			<form action="" class="contact-form__form" [formGroup]="formEmail">
				<div class="contact-form__block">
					<input class="contact-form__input" placeholder="email" formControlName="email"
						   (ngModelChange)="onInputChange()">
					<label *ngIf="formEmail.controls['email'].invalid && formEmail.controls['email'].touched">
						Неверный формат
					</label>
					<label *ngIf="formError">
						{{errorMessage}}
					</label>
				</div>
				<button class="contact-form__button"
						[disabled]="formEmail.invalid"
						[ngClass]="formEmail.invalid ? 'form__button--disabled' : ''"
						(click)="onSubmit()">Отправить</button>
			</form>
		</div>
	</div>
</section>

<app-successful-internship></app-successful-internship>
